export default param => {
  return (param === param.toLowerCase())
}
